<!--
@Author: MIYONGLE
@Desc: 首页
@Date: 2021-04-16 18时
-->
<template>
  <div class="page-main">
    <!-- 顶部 -->
    <mMenusNav><span>{{ titleName }}</span></mMenusNav>

    <!-- bannar -->
    <van-swipe :autoplay="3000" :show-indicators="false">
      <van-swipe-item>
        <div class="index_bg">
          <div class="title">
            <p>场景化</p>
            <p>灵活用工服务平台</p>
          </div>
          <div class="text">
            慧用工基于云计算和大数据技术，构建了灵活用工行业的全流程数字化解决方案。重构企业与人的用工关系，打造高效便捷、合作共赢的网络体系。
          </div>
          <div class="free_btn" @click="openMath">免费体验</div>

          <!-- 轮播图存放样式 -->
          <div class="home">
            <img src="../../../static/mobile/index/banner_home_11.png" alt="" />
            <div class="footer_select">
              <div class="footer_line1"></div>
              <div class="footer_line2"></div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="index_bg2">
          <div class="title">
            <p>慧用工灵活用工系统</p>
            <p>通过三级等保认证</p>
          </div>
          <div class="text">
            中华人民共和国公安部颁发：<br />《信息系统安全等级保护备案证明》
          </div>
          <div class="free_btn" @click="openMathKnow">了解详情</div>
          <!-- 轮播图存放样式 -->
          <div class="home">
            <!-- 海南更换为湖南 -->
            <img src="../../../static/mobile/index/banner_home_22.jpg" alt="" />
            <div class="footer_select">
              <div class="footer_line2"></div>
              <div class="footer_line1"></div>
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    
    <!-- 我们能为你做什么 -->
    <div class="index_body">
      <div class="title">我们能为你做什么</div>
      <ul v-for="img in imgArray" :key="img.title">
        <li class="banner_img" :style="{ 'background-image': 'url(' + img.src + ')' }">
          <div class="titleName">{{ img.titleName }}</div>
          <div class="centent">{{ img.centent }}</div>
        </li>
      </ul>
    </div>

    <!-- 我们的服务行业 -->
    <div class="index_service">
      <div class="service_title">我们的服务行业</div>
      <!-- 轮播图 -->
      <m-swipe></m-swipe>
    </div>

    <!-- 地图 -->
    <div class="map">
      <div class="img">
        <img src="../../../static/mobile/index/home_map.png" alt="" />
      </div>
      <ul class="map_number">
        <li v-for="item in mapArray" :key="item.text">
          <p class="map_shuju" v-if="item.text == '服务行业' || item.text == '服务企业'"><span>{{ item.numberTemp }}</span>+</p>
          <p class="map_shuju" v-else-if="item.text == '服务自由职业者'"><span>{{ item.numberTemp }}</span>万+</p>
          <p class="map_shuju" v-else><span>{{ item.numberTemp }}</span>亿+</p>
          <p class="map_text">{{ item.text }}</p>
        </li>
      </ul>
    </div> 

    <!-- 合作伙伴 -->
    <div class="partner">
      <div class="title">合作伙伴</div>
      <div class="img">
        <img src="../../../static/mobile/index/img_hezuohuoban.png" alt="" />
      </div>   
    </div>

    <!--立即预约-->
    <div class="appointment">
      <div class="information">
        <mFromPage
        :source="paramQuery.source"
          ><span class="pop-box-title"
            >慧用工｜致力于助力每一个优秀的公司</span
          ></mFromPage
        >
      </div>
    </div>
    <!-- form弹窗 -->
    <mFrom :source='paramQuery.source'></mFrom>
  </div>
</template>

<script type="text/javascript">
import mMenusNav from "../../components/mMenusNav";
import mFrom from "../../components/mFrom";
import mSwipe from "../../components/mSwipe.vue";
import {
  BANNER_CAN_DO,
  BANNER_SERVICE,
  MAP_CON_LIST,
} from "../../service/businessConsts";
import mFromPage from "../../components/mFromPage";
import { checkNull } from "../../filters/filters";

export default {
  name: "mIndex-Page",
  data() {
    return {
      current: 0,
      paramQuery: {
        name:'',
        phone:'',
        companyName:'',
        source:'',
        bdVid:'',
      },   

      titleName: "首页",
      loop: true,
      timerTemp: null,
      imgArray: BANNER_CAN_DO,
      bannerArray: BANNER_SERVICE,
      mapArray: MAP_CON_LIST,
      step:0,//定义一个可以左右点击图片变动的按钮
    };
  },

  components: {
    mMenusNav: mMenusNav,
    mFrom: mFrom,
    mSwipe: mSwipe,
    mFromPage: mFromPage,
  },

  created() {
    // this.paramQuery.bdVid = this.$route.query.bd_vid;
    if(!checkNull(this.$route.query.bd_vid)){
      if (this.$route.query.bd_vid.length > 1) {
        this.paramQuery.bdVid = this.$route.query.bd_vid[1];
      }else{
        this.paramQuery.bdVid = this.$route.query.bd_vid
      }
    }
    
    // source来源：：
    let hash = window.location.hash;
    this.paramQuery.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=msy' : '&pageFrom=msy';

  },

  methods: {

    // 地图数字
    getMapNumMth(){
      this.mapArray[0].numberTemp = 20;
      this.mapArray[1].numberTemp =  3680;
      this.mapArray[2].numberTemp =  2;
      this.mapArray[3].numberTemp =  49;
      this.getMapTimerMth();
    },

    //地图数字
    getMapTimerMth(){
      this.timerTemp = setInterval(() => this.mapArray.forEach(item=>{
        item.numberTemp ++;
        if(item.numberTemp == item.number){
          clearInterval(this.timerTemp);
          this.mapArray[0].numberTemp = 40;
          this.mapArray[1].numberTemp =  3700;
          this.mapArray[2].numberTemp =  20;
          this.mapArray[3].numberTemp =  68;
        }
      }), 100);
    },

    openMath(){
      eventBus.$emit("operaDiaLog", true);
    },

    openMathKnow(){
      window.location.href = 'https://www.hvyogo.com/#/mNewsAndInfoDetail?id=10061'
    },

  },

  beforeDestroy() {
    clearInterval(this.timerTemp);
  },
};
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}
.index_bg {
  width: 100%;
  height: 1080px;
  overflow: hidden;
  background: linear-gradient(180deg, #100f0f 0%, #002979 100%);
  .title {
    margin: 0 auto;
    margin-top: 177px;
    // width: 622px;
    height: 152px;
    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 76px;
  }
  .text {
    margin: 0 auto;
    margin-top: 28px;
    // width: 540px;
    padding: 0px 105px;
    height: 120px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
  }
  .free_btn {
    margin: 0 auto;
    margin-top: 55px;
    width: 288px;
    height: 80px;
    background: #1985ff;
    border-radius: 40px;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 80px;
  }
  .home {
    margin: 0 auto;
    margin-top: 36px;
    width: 599px;
    height: 402px;
    overflow: hidden;
    img {
      margin: 0 auto;
      width: 542px;
      height: 369px;
    }
    .footer_select {
      width: 78px;
      height: 6px;
      margin: 0 auto;
      margin-top: 15px;
      .footer_line1 {
        width: 60px;
        height: 6px;
        background: #1985ff;
        border-radius: 6px;
        float: left;
      }
      .footer_line2 {
        width: 6px;
        height: 6px;
        float: right;
        background: #ffffff;
        border-radius: 6px;
      }
    }
  }
}
.index_bg2 {
  width: 100%;
  height: 1080px;
  overflow: hidden;
  background: linear-gradient(180deg, #1279ed 0%, #1060ff 100%);
  .title {
    margin: 0 auto;
    margin-top: 177px;
    height: 152px;
    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 76px;
  }
  .text {
    margin: 0 auto;
    margin-top: 28px;
    padding: 0px 105px;
    height: 120px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
  }
  .free_btn {
    margin: 0 auto;
    margin-top: 55px;
    width: 288px;
    height: 80px;
    color: #1985ff;
    border-radius: 40px;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    background: #ffffff;
    line-height: 80px;
  }
  .home {
    margin: 0 auto;
    margin-top: 91px;
    width: 750px;
    height: 377px;
    overflow: hidden;
    position: relative;
    img {
      margin: 0 auto;
      width: 750px;
      height: 377px;
    }
    .footer_select {
      position: absolute;
      width: 78px;
      height: 6px;
      left: 336px;
      bottom: 30px;
      .footer_line1 {
        width: 60px;
        height: 6px;
        background: #1985ff;
        border-radius: 6px;
        float: right;
      }
      .footer_line2 {
        width: 6px;
        height: 6px;
        float: left;
        background: #ffffff;
        border-radius: 6px;
      }
    }
  }
}

.index_body {
  margin:0 auto;
  width: 100%;
  height: 1383px;
  overflow: hidden;
  background: #ffffff;
  .title {
    margin: 70px auto 31px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100f0f;
    line-height: 56px;
  }
  .banner_img {
    background-size: cover;
    margin: 0 auto;
    margin-top: 10px;
    width: 690px;
    height: 299px;
    overflow: hidden;
    .titleName {
      margin: 70px auto 16px;
      height: 45px;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 45px;
    }
    .centent {
      margin: 0 auto;
      padding: 0 60px;
      height: 96px;
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      word-break : normal;
    }
  }
}
.index_service {
  width: 100%;
  height: 680px;
  position: relative;
  overflow: hidden;
  .service_title {
    margin: 70px auto 31px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100f0f;
    line-height: 56px;
  }
  
}

.map {
  width: 100%;
  height: 782px;
  background: #000000;
  overflow: hidden;
  .img {
    margin: 0 auto;
    margin-top: 34px;
    width: 700px;
    height: 550px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .map_number {
    margin-top: 53px;
    // width: 750px;
    height: 87px;
    display: flex;
    justify-content: space-evenly;
    .map_shuju {
      font-size: 44px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: #1985ff;
      line-height: 51px;
    }
    .map_text {
      margin-top: 9px;
      font-size: 18px;
      font-family: SourceHanSansSC-Medium, SourceHanSansSC;
      font-weight: 500;
      color: #ffffff;
      line-height: 27px;
    }
  }
}

.partner {
  width: 100%;
  height: 748px;
  overflow: hidden;
  background: #fbfdff;
  .title {
    margin: 70px auto 32px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100f0f;
    line-height: 56px;
  }
  .img{
    margin:0 auto;
    height: 559px;
    img{
      height: 100%;
    }
  }
}

.appointment{
  width: 100%;
  overflow: hidden;
  background-image: url(../../../static/mobile/index/img_bg.png);
  background-repeat:no-repeat;
  background-size: 100%;
  background-color: #F9FBFD;
  .information{
    margin: 110px 30px 58px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mIndexPage.vue